import React, { ReactElement } from "react";
import { ToelichtingVerantwoordeWoonlastenHoofdstuk } from "../../../../../../.generated/rapportage/rapportagetypes";
import { Motivering } from "../../../../components/Motivering";
import { Chapter } from "../../../../components/Chapter";
import Heading from "../../../../components/Heading";
import { VerantwoordeWoonlastenTabel } from "./verantwoorde-woonlasten-tabel";
import { Paragraph } from "../../../../components/Paragraph";

export const ToelichtingAdviesVerantwoordeWoonlastenChapter = ({
  hoofdstuk,
}: {
  hoofdstuk: ToelichtingVerantwoordeWoonlastenHoofdstuk;
}): ReactElement => {
  return (
    <Chapter>
      <div className="break-avoid">
        <Heading text="Verantwoorde woonlasten" level={3} />
        <Paragraph>{hoofdstuk?.paragrafen?.p306020201?.inhoud}</Paragraph>
        <Motivering
          wens={hoofdstuk.wens}
          advies={hoofdstuk?.advies}
          keuze={hoofdstuk?.keuze}
        />
        {hoofdstuk.verantwoordeWoonlastenScenarios &&
          hoofdstuk.verantwoordeWoonlastenScenarios.length > 0 && (
            <VerantwoordeWoonlastenTabel
              scenarios={hoofdstuk.verantwoordeWoonlastenScenarios}
              normJaar={hoofdstuk.normJaar}
            />
          )}
      </div>
    </Chapter>
  );
};
